module.exports = __webpack_public_path__ + "static/media/plus-icon.8ed37d1b.svg";